module.exports = require("./so.d.ts");